import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const divStyle = {
  paddingTop: '30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
  }

  renderHeader() {
    return <Fragment><th key="period">Period</th><th key="type">Type</th><th key="accepted">Accepted?</th><th key="actions" colSpan="2">Actions</th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.vacations.vacations))
    return Object.keys(myData).map((key) => {
      const vacation = myData[key]
      return <tr key={key}><td>{vacation['start']} to {vacation['end']}</td><td>{vacation['type']}</td><td>{vacation['accepted']}</td><td colSpan="2"><span><a href="#" onClick={() => this.handleSubmit(vacation['id'], vacation['user_id'])} style={linkStyle}>Cancel vacation</a></span></td></tr>
    }
    )
  }

  handleSubmit(idV, idU) {
    const urlf = '/api/v1/destroy_vacation'
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure you want to cancel this time off?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let body = ''
            body = JSON.stringify({id: idU, vacation_id: idV})
            fetch(urlf, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: body,
            })
            .then(response => response.json())
            .then((data) => {
              if (data.type === 'success'){
                document.getElementById('mylink').click()
              } else {
                console.error('err' + data.message)
              }
            })
            .catch((err) => {
              console.error('Error while cancelling time off! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }

  render() {
    const myData = [].concat(Object.values(this.props.vacations.vacations))
    const empl = myData[0]['user_id']
    const ref = '/myvacations/' + empl.toString()
    return <Fragment><h4>My upcoming vacations</h4><div className="justify-content-center align-items-center" style={divStyle}><a href={ref} id="mylink" style={aStyle}></a><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div></Fragment>
  }

}

Table.propTypes = {
  vacations: PropTypes.object,
}

export default Table
